// extracted by mini-css-extract-plugin
export default {"container":"DraggableImage_container__34Hfu","image":"DraggableImage_image__ONNFq","ribbon":"DraggableImage_ribbon__i2wXh","delete":"DraggableImage_delete__Mee1V"};